module.exports = __webpack_public_path__ + "img/home-9.14aec66e.png";